import React from 'react'
import EquipmentSlot from './EquipmentSlot'
import EquipmentMannequinFigure from './EquipmentMannequinFigure'
import { getEquipmentSlotValue, isOffHandBlockedByTwoHand } from '../utils/slotUtils'

const PENTAGON_SLOTS = [
  { slotType: 'head', className: 'char-equipo__pentagon-slot--head', caption: 'Casco' },
  { slotType: 'hands', className: 'char-equipo__pentagon-slot--hands', caption: 'Guantes' },
  { slotType: 'chest', className: 'char-equipo__pentagon-slot--chest', caption: 'Pecho' },
  { slotType: 'legs', className: 'char-equipo__pentagon-slot--legs', caption: 'Pantalones' },
  { slotType: 'feet', className: 'char-equipo__pentagon-slot--feet', caption: 'Botas' },
]

const EXTRA_GROUPS = [
  { title: 'Armas', slots: ['mainHand', 'offHand'] },
  { title: 'Accesorios', slots: ['ring1', 'ring2', 'necklace', 'earring1', 'earring2'] },
  { title: 'Consumibles', slots: ['consumable0', 'consumable1', 'consumable2', 'consumable3', 'consumable4'] },
]

function SectionHeader({ title }) {
  return (
    <div className="char-section-header char-equipo__section-header">
      <span className="char-section-header__ornament" aria-hidden="true" />
      <h3 className="char-section-header__title">{title}</h3>
      <span className="char-section-header__ornament char-section-header__ornament--right" aria-hidden="true" />
    </div>
  )
}

export default function EquipmentMannequin({
  character,
  slug,
  equipment,
  woundZones = {},
  onDragStart,
  onDragEnd,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onDrop,
  getDragClasses,
  canEquipItemInSlot,
  onUnequipItem,
}) {
  const handleItemClick = (item, slotType, sourceType) => {
    if (sourceType === 'equipment' && item) {
      onUnequipItem(slotType)
    }
  }

  const slotProps = {
    onDragStart,
    onDragEnd,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop,
    onClick: handleItemClick,
  }

  const offHandBlocked = isOffHandBlockedByTwoHand(equipment)

  const renderSlot = (slotType, variant = '') => {
    const disabled = slotType === 'offHand' && offHandBlocked
    return (
      <EquipmentSlot
        key={slotType}
        slotType={slotType}
        item={disabled ? null : getEquipmentSlotValue(equipment, slotType)}
        dragClasses={disabled ? '' : getDragClasses('equipment', slotType, canEquipItemInSlot)}
        className={`char-equipo__slot ${variant}`.trim()}
        disabled={disabled}
        disabledReason="Ocupada por arma a dos manos"
        {...slotProps}
      />
    )
  }

  return (
    <section className="char-equipo__gear" aria-label="Equipamiento">
      <div className="char-equipo__armor-panel char-card--section">
        <SectionHeader title="Armadura" />

        <div className="char-equipo__pentagon-wrap">
          <div className="char-equipo__pentagon" aria-label="Piezas de armadura">
            <div className="char-equipo__pentagon-glow" aria-hidden="true" />
            <div className="char-equipo__pentagon-ring" aria-hidden="true" />

            {PENTAGON_SLOTS.map(({ slotType, className, caption }) => {
              const wound = woundZones[slotType] || null
              return (
                <div
                  key={slotType}
                  className={`char-equipo__pentagon-slot ${className}${
                    wound ? ` char-equipo__pentagon-slot--wounded char-equipo__pentagon-slot--wounded-${wound.severity}` : ''
                  }`}
                >
                  {renderSlot(slotType, 'char-equipo__slot--armor')}
                  <span className="char-equipo__slot-caption">{caption}</span>
                  {wound ? (
                    <span
                      className="char-equipo__wound-mark"
                      title={wound.text ? `${wound.label}: ${wound.text}` : wound.label}
                      aria-label={`Zona herida: ${caption}`}
                    >
                      ✚
                    </span>
                  ) : null}
                </div>
              )
            })}

            <div className="char-equipo__pentagon-center">
              <EquipmentMannequinFigure char={character} slug={slug} />
            </div>
          </div>
        </div>
      </div>

      <div className="char-equipo__extras-panel char-card--section">
        <SectionHeader title="Complementos" />
        <div className="char-equipo__extras">
          {EXTRA_GROUPS.map((group) => (
            <div key={group.title} className="char-equipo__extra-row">
              <span className="char-equipo__extra-label">{group.title}</span>
              <div className="char-equipo__extra-slots">
                {group.slots.map((slotType) => renderSlot(slotType, 'char-equipo__slot--extra'))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
